import BaseStore from "./baseStore";
export const namespaced = true;
import { getNewId } from "@/utils/id";
import api from "../api/api";

const baseUrl = "/soil_profile_points/";

const baseStore = new BaseStore(baseUrl);

const getDefaultState = () => {
  return {
    ...structuredClone(baseStore.state),
    group: 0,
  };
};

export const state = getDefaultState();

export const mutations = {
  ...baseStore.mutations
};

export const actions = {
  ...baseStore.actions,
  addBlockSoilProfile(context, { soil_profile, z }) {
    let ids = getNewId(context.state.items, "id");
    let item = {
      z: z,
      soil_profile: soil_profile,
      id: ids,
    };
    context.commit("ADD_ITEM", item);
  },
  async deleteItems(context, items) {
    const url = context.state.baseUrl + `bulk_delete/`;
    let delObj = items.filter((item) => item.id > 0);
    if (delObj.length) {
      await api.post(url, delObj);
    }
    items.forEach((item) => {
      context.commit("DELETE_ITEM", item.id);
    });
  },
  async fetchSoilProfilePoints(context, id) {
    context.commit("TOGGLE_LOADING");
    let url = context.state.baseUrl + `?search=${id}`;
    let response = await api.get(url);
    context.commit("SET_ITEMS", response.data);
    context.commit("ADD_COUNT", response.data.length);
    context.commit("TOGGLE_LOADING");
  },
  async createSoilProfilePoint(context) {
    context.commit("TOGGLE_WRITE_LOADING");
    let newObjs = context.state.items.filter((item) => item.id <= 0);
    if (newObjs.length) {
      try {
        let response = await api.post(baseUrl, newObjs);
        context.commit("REPLACE_ITEMS", { newObjs, createdObjs: response.data });
      } catch (e) {
        console.log(e);
      }
    }
    context.commit("TOGGLE_WRITE_LOADING");
  },
};

export const getters = {
  getSoilProfilePointById: (state) => (soilProfileId) => {
    return state.items
      ? state.items
          .filter((item) => item.soil_profile === soilProfileId)
          .sort(function (a, b) {
            return b["z"] - a["z"];
          })
      : [];
  },
};
